import React from 'react';
import { useSelector } from 'react-redux';
import { getSession } from './redux/selectors';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
const SessionProvider = ({ children })=>{
    const session = useSelector(getSession);
    return /*#__PURE__*/ React.createElement(SessionContext.Provider, {
        value: session
    }, children);
};
SessionProvider.displayName = 'SessionProvider';
export default SessionProvider;

//# sourceMappingURL=SessionProvider.js.map